import { render, staticRenderFns } from "./CmgGuacModeBadge.vue?vue&type=template&id=71ff0eee&scoped=true&lang=pug&"
import script from "./cmg-guac-mode-badge.ts?vue&type=script&lang=ts&"
export * from "./cmg-guac-mode-badge.ts?vue&type=script&lang=ts&"
import style0 from "./CmgGuacModeBadge.vue?vue&type=style&index=0&id=71ff0eee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ff0eee",
  null
  
)

export default component.exports